import { AccessTime, ChevronLeft, ChevronRight } from "@mui/icons-material";
import {
  addDays,
  addHours,
  format,
  isAfter,
  isBefore,
  subDays,
} from "date-fns";
import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../../assets/css/MiniCalendar.css";
import { differenceInDays } from "date-fns";
import {
  converterDateTime,
  ethDateTime,
  toEthiopianDateTime,
} from "../../util/Ethiopia/Ethiopia";
export function habeshaFormat(europeanDate, format) {
  const ethiopianDate = converterDateTime.toEthiopian(europeanDate);
  if (!ethiopianDate) {
    return false;
  }

  // Define the tokens and their corresponding values
  const tokens = {
    MMM: ethiopianDate.monthname,
    dd: ethiopianDate.date,
    yyyy: ethiopianDate.year,
    // Add more tokens here as needed
  };

  let formattedDate = format;

  // Replace each token in the format string
  for (const [token, value] of Object.entries(tokens)) {
    formattedDate = formattedDate.replace(token, value);
  }

  return formattedDate;
}
const EthiopianDatePicker = ({
  selectedDate,
  setSelectedDate,
  month,
  min,
  max,
}) => {
  const [monthDates, setMonthDates] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(
    new Date(month) || new Date()
  );
  for (var i = 0; i < 48; i++) {
    console.log(
      converterDateTime.toEthiopian(
        new Date(
          addHours(
            new Date("Wed Sep 06 2023 00:00:00 GMT+0300 (East Africa Time)"),
            i
          )
        )
      )
    );
  }
  function getCurrentWeekSundayEthiopian(ethDate) {
    const today = ethDate.date; // Assuming .date gives the day of the month
    const currentDay = ethDate.getDay(); // Assuming .day gives the day of the week

    // If today is Sunday (which might be represented differently in Ethiopian calendar)
    if (currentDay === 0) {
      return new Date(converterDateTime.toEuropean(ethDate));
    }
    return new Date(
      subDays(
        converterDateTime.toEuropean(ethDate),
        Math.abs(today - currentDay)+1
      )
    );
  }
  const getMonthDates = (date) => {
    if (!date) {
      return false;
    }
    let firstDayOfMonth, lastDayOfMonth, firstDayOfCalendar, lastDayOfCalendar;

    firstDayOfMonth = toEthiopianDateTime(
      new Date(date.getFullYear(), date.getMonth(), 1)
    );
    lastDayOfMonth = toEthiopianDateTime(
      new Date(date.getFullYear(), date.getMonth() + 1, 0)
    );

    firstDayOfCalendar = getCurrentWeekSundayEthiopian(
      new ethDateTime(
        1,
        converterDateTime.toEthiopian(date).month,
        converterDateTime.toEthiopian(date).year
      )
    );
    lastDayOfCalendar = addDays(
      converterDateTime.toEuropean(
        new ethDateTime(
          new ethDateTime(
            1,
            converterDateTime.toEthiopian(date).month,
            converterDateTime.toEthiopian(date).year
          ).monthname.includes("Pagume")
            ? typeof converterDateTime.toEuropean(
                new ethDateTime(
                  6,
                  converterDateTime.toEthiopian(date).month,
                  converterDateTime.toEthiopian(date).year
                )
              ) == "string"
              ? 5
              : 6
            : 30,
          converterDateTime.toEthiopian(date).month,
          converterDateTime.toEthiopian(date).year
        )
      ),
      1
    );

    let dates = [];
    let currentDate = firstDayOfCalendar;
    while (currentDate <= lastDayOfCalendar) {
      dates.push(new Date(currentDate));
      currentDate = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate() + 1
      );
    }
    return dates;
  };
  console.log(converterDateTime.toEthiopian(new Date(selectedDate)));
  console.log(converterDateTime.toEthiopian(new Date(currentMonth)));
  function areDatesEqual(date1, date2) {
    return date1.getDate() === date2.getDate();
  }
  const handleNextMonth = () => {
    var nextMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() + 1,
      1
    );
    if (
      (currentMonth.getMonth() == 8 || currentMonth.getMonth() == 7) &&
      converterDateTime
        .toEthiopian(currentMonth)
        .monthname.includes("Pagume") == false
    ) {
      nextMonth = new Date(
        addDays(
          converterDateTime.toEuropean(
            new ethDateTime(1, 13, getLocalizedMonth(currentMonth, "year"))
          ),
          1
        )
      );
    }

    setMonthDates(getMonthDates(nextMonth));
    setCurrentMonth(nextMonth);
    const newMonthStr = nextMonth.toISOString().substring(0, 7);
  };
  useEffect(() => {
    setMonthDates(getMonthDates(currentMonth));
  }, []);
  const handlePreviousMonth = () => {
    var previousMonth = new Date(
      currentMonth.getFullYear(),
      currentMonth.getMonth() - 1,
      1
    );
    if (
      currentMonth.getMonth() == 9 &&
      converterDateTime
        .toEthiopian(currentMonth)
        .monthname.includes("Pagume") == false
    ) {
      previousMonth = new Date(
        addDays(
          converterDateTime.toEuropean(
            new ethDateTime(1, 13, getLocalizedMonth(currentMonth, "year") - 1)
          ),
          1
        )
      );
    }
    if (
      converterDateTime.toEthiopian(currentMonth).monthname.includes("Pagume")
    ) {
      previousMonth = new Date(
        addDays(
          converterDateTime.toEuropean(
            new ethDateTime(1, 12, getLocalizedMonth(currentMonth, "year"))
          ),
          1
        )
      );
    }

    setMonthDates(getMonthDates(previousMonth));
    setCurrentMonth(previousMonth);
  };
  function areDatesEqual(date1, date2) {
    if (!date2) {
      return false;
    }
    date2 = new Date(date2);
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }
  const handleSelectDate = (date) => {
    if (min) {
      isAfter(
        new Date(date).setHours(0, 0, 0),
        new Date(min).setHours(0, 0, 0)
      ) && setSelectedDate(date);
    } else if (max) {
      isBefore(
        new Date(date).setHours(0, 0, 0),
        new Date(max).setHours(0, 0, 0)
      ) && setSelectedDate(date);
    } else {
      setSelectedDate(date);
    }
  };
  const getLocalizedWeekdays = () => {
    return ["እሁድ", "ሰኞ", "ማክሰኞ", "ረቡዕ", "ሐሙስ", "ዓርብ", "ቅዳሜ"];
  };

  const getLocalizedMonth = (date, year) => {
    return year
      ? toEthiopianDateTime(date).year
      : toEthiopianDateTime(date).monthname;
  };

  // Conversion utility to be used when displaying Ethiopian dates
  const toEthiopianDate = (date) => {
    return converterDateTime.toEthiopian(new Date(new Date(date)))
      .date;
  };

  const displayDate = (date) => {
    return toEthiopianDate(date);
  };
  console.log(selectedDate);
  const weekdays = getLocalizedWeekdays();
  return (
    <div style={{ display: "flex", gap: "20px" }}>
      <div
        className={"habesha-calendar-container "}
        style={{
          maxWidth: "100%",
          width: "100%",
          flex: 1.4,
          position: "relative",
          minHeight: "325px",
        }}
      >
        <div>
          <div className="header">
            <h3 className="month">
              {getLocalizedMonth(currentMonth)}{" "}
              {getLocalizedMonth(currentMonth, "year")}
            </h3>
            <div style={{ display: "flex" }}>
              <ChevronLeft
                disabled
                className={`prev-btn`}
                onClick={handlePreviousMonth}
              />
              <ChevronRight className={`next-btn`} onClick={handleNextMonth} />
            </div>
          </div>

          <div className="calendar-grid" style={{ minHeight: "130px" }}>
            {weekdays.map((day) => (
              <div key={day} className="weekday">
                {day.toUpperCase().slice(0, 3)}
              </div>
            ))}
            {monthDates.map((date, index) => {
              const disabled = differenceInDays(date, new Date()) < 0;
              return (
                <div
                  style={{
                    height: "50px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div
                    onClick={
                      disabled
                        ? null
                        : () =>
                            handleSelectDate(
                              new Date(new Date(date))
                            )
                    }
                    key={index}
                    style={{
                      display:
                        converterDateTime.toEthiopian(
                          new Date(new Date(date))
                        ).month !=
                        converterDateTime.toEthiopian(new Date(currentMonth))
                          .month
                          ? "none"
                          : "inherit",
                    }}
                    className={`calendar-date ${
                      disabled
                        ? areDatesEqual(date, selectedDate)
                          ? "sped"
                          : "disabled"
                        : ""
                    } ${
                      differenceInDays(date, new Date()) < 0 &&
                      !areDatesEqual(date, selectedDate)
                        ? "past"
                        : ""
                    } ${
                      areDatesEqual(date, selectedDate) && !disabled
                        ? "selected"
                        : ""
                    }`}
                  >
                    {displayDate(date)}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};
export default EthiopianDatePicker;
